export function migrateV3ToV4(template: any): any {
  if (!template || typeof template !== 'object') return template
  const cloned = { ...template }
  const charts = Array.isArray(cloned.chartConfigs) ? cloned.chartConfigs : []
  cloned.chartConfigs = charts.map((cfg: any) => ({
    ...(cfg || {}),
    legendCorner: (cfg && cfg.legendCorner) ? cfg.legendCorner : 'tr'
  }))
  cloned.version = 4
  return cloned
}

